import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async"; // 1. Importar HelmetProvider


import App from "./App";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <StrictMode>
    {/* 2. Envolver la App con el Provider */}
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </StrictMode>
);
